<template>
    <language-items v-bind="$attrs" text class="language-items--text">
        <slot />
    </language-items>
</template>

<script>
import LanguageItems from "@/components/publish/styles/headers/language-items.vue";

export default {
    props: {
        text: Boolean,
    },
    components: {
        LanguageItems,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
